import React, { useRef } from "react";
import * as styles from "./SkipToContent.module.scss";

export const SkipToContent: React.FC = () => {
	const skipToContentAnchorTag = useRef<HTMLDivElement>();

	const handleFocusOfSkipToContentAnchor = () => {
		skipToContentAnchorTag.current.className = styles.skiptovisible;
	};
	const handleBlurOfSkipToContentAnchor = () => {
		skipToContentAnchorTag.current.className = styles.skiptoinvisible;
	};

	return (
		<div ref={skipToContentAnchorTag} className={styles.skiptoinvisible}>
			<a
				href="#main-content"
				id="skip-to-content-anchor"
				onFocus={() => handleFocusOfSkipToContentAnchor()}
				onBlur={() => handleBlurOfSkipToContentAnchor()}
			>
				<u>Skip To Content</u>
			</a>
		</div>
	);
};

export default SkipToContent;
